import { useMutation } from '@tanstack/react-query';
import { HTTPError } from 'ky';
import toast from 'react-hot-toast';
import { queryClient, subscriptionApi } from '~/lib/request';
import useActiveSubscription from './useActiveSubscription';

function useCancelSubscription() {
  const { data: activePlan } = useActiveSubscription();
  const result = useMutation({
    mutationFn: (reason: string) =>
      subscriptionApi
        .post('api/subscriptions/cancel', {
          json: {
            subscription_id: activePlan?.id,
            reason,
          },
        })
        .json(),

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['balance'] });
      queryClient.invalidateQueries({ queryKey: ['activeSubscription'] });

      toast.success('Subscription cancelled');
    },
    onError: async (error) => {
      console.log(error);

      let errorDetail = 'Please try again later';

      if (error instanceof HTTPError) {
        const errorData = error.data as { detail: string };
        errorDetail = errorData?.detail || '';
      }

      toast.error(errorDetail);
    },
  });

  return result;
}

export default useCancelSubscription;
